<template>
    <div v-if="spinner==true" class="spinner"></div>
    <div :class="spinner == true?'difuminado':''">
        <div class="card">
            <div class="card-header">
                <p class="card-title"> Autofacturación Operarios</p>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4">
                        <div style="display:flex; margin-bottom: 1rem ; flex-direction: column;">
                            <label for="opers">Operarios</label>
                            <Dropdown :disabled="no_factura==1 ? true : false" :title="no_factura==0?'':'Solo activo para sistema VeriFactu'" id="opers" 
                                v-model="selectedprovoper" :options="provoper" optionLabel="label" optionGroupLabel="label"
                                optionGroupChildren="items" placeholder="Seleccione operario/proveedor" filter scrollHeight="400px"/>
                        </div>
                        <div class="form-group">
                            <label for="empre">Empresas</label>
                            <select v-model="empresaselec" class="form-control form-control-sm" name="" id="empr">
                                <option value="">Todas</option>
                                <option v-for="empr in empresas" :key="empr.id" :value="empr.id">{{ empr.nombre_empresa }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-1"></div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="inicio">Fecha Inicio</label>
                            <input :disabled="inicioBloqueado" class="form-control form-control-sm" v-model="fechaInicio" type="date">
                        </div>
                        <div class="form-group">
                            <label for="inicio">Fecha Final</label>
                            <input :disabled="finBloqueado" class="form-control form-control-sm" v-model="fechaFin" type="date">
                        </div>
                    </div>
                    <div class="col-md-1">
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="inicio">Fecha Factura</label>
                            <input :disabled="leyAntiActivada" class="form-control form-control-sm" v-model="fechaFactura" type="date">
                        </div>                    
                        <div class="form-group">
                            <label for="inicio">Nº Factura</label>
                            <input :disabled="nFacturaBloqueado || leyAntiActivada" class="form-control form-control-sm" v-model="nFactura" type="number">
                        </div>
                    </div>
                    <div class="col-md-1">
                    </div>
                    <div class="col-md-1" style="align-items: end;justify-content: end; display: flex;">
                        <button :disabled="no_factura==1 ? true : false" :title="no_factura==0?'':'Solo activo para sistema VeriFactu'" @click="cargarPrevio" class="btn btn-sm btn-default">Previo</button>
                    </div>
                </div>
                <Dialog v-model:visible="previoDialog" modal header="Detalle de trabajos a incluir en la factura" :style="{ width: '80rem' }">
                    <template #closeicon>
                        <i @click="previoDialog = false;previoCargado = false" class="pi pi-times"></i>
                    </template>
                    <div class="card"><div class="card-body" style="padding: 0px;">
                        <div class="table-responsive">
                            <table class="table table stripped" style="margin:0px;">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Método Factura</th>
                                        <th>Operario/Proveedor</th>
                                        <th>NIF</th>
                                        <th style="text-align:right;">Total €</th>
                                        <th style="text-align:right;">Total IVA €</th>
                                        <th v-if="camposextra" style="text-align:right;">Pendiente CIA. €</th>
                                        <th v-if="camposextra" style="text-align:right;">Facturado CIA. €</th>
                                        <th v-if="camposextra" style="text-align:right;">Cobrado CIA. €</th>
                                        <th><input type="checkbox" v-model="checktodos"></th>
                                    </tr>
                                </thead>
                                <tbody v-for="operario in operarios" :key="operario.id_operario">
                                    <tr @click="operario.mostrar = !operario.mostrar">
                                        <td v-if="operario.mostrar"><i class="fas fa-angle-down"></i></td>
                                        <td v-else><i class="fas fa-angle-right"></i></td>
                                        <td>{{ operario.metodo }}</td>
                                        <td>{{ operario.operario }}</td>
                                        <td>{{ operario.codigo}}</td>
                                        <td style="text-align:right;">{{ operario.importe_total }}</td>
                                        <td style="text-align:right;">{{ operario.importe_iva }}</td>
                                        <td v-if="camposextra" style="text-align:right;">{{ operario.pendiente_total }}</td>
                                        <td v-if="camposextra" style="text-align:right;">{{ operario.facturado_total }}</td>
                                        <td v-if="camposextra" style="text-align:right;">{{ operario.cobrado_total }}</td>
                                        <td><input type="checkbox" @click.stop="cambiocheck(operario)" v-model="operario.check"></td>
                                    </tr>
                                    <tr v-if="operario.mostrar">
                                        <td>
                                        </td>
                                        <td colspan="8">
                                            <div class="table-responsive">
                                                <table class="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th><small><b>Nombre</b></small></th>
                                                            <th><small><b>Expediente</b></small></th>
                                                            <th style="text-align:right;"><small><b>Total €</b></small></th>
                                                            <th style="text-align:right;"><small><b>Total IVA €</b></small></th>
                                                            <th v-if="camposextra" style="text-align:right;"><small><b>Pdte CIA. €</b></small></th>
                                                            <th v-if="camposextra" style="text-align:right;"><small><b>Facturado CIA. €</b></small></th>
                                                            <th v-if="camposextra" style="text-align:right;"><small><b>Cobrado CIA. €</b></small></th>
                                                            <th><small><b>Fecha ini.</b></small></th>
                                                            <th><small><b>Fecha fin</b></small></th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="[id, trabajo] in Object.entries(operario.trabajos)" :key="id">
                                                            <td><small>{{ trabajo.cliente }}</small></td>
                                                            <td><small style="cursor: pointer; color: #007bff;" @click="irAExpediente(trabajo)">{{ trabajo.expediente }}</small></td>
                                                            <td style="text-align:right;"><small>{{ trabajo.importe_total }}</small></td>
                                                            <td style="text-align:right;"><small>{{ trabajo.importe_iva }}</small></td>
                                                            <td v-if="camposextra" style="text-align:right;"><small>{{ trabajo.pendiente_total }}</small></td>
                                                            <td v-if="camposextra" style="text-align:right;"><small>{{ trabajo.facturado_total }}</small></td>
                                                            <td v-if="camposextra" style="text-align:right;"><small>{{ trabajo.cobrado_total }}</small></td>
                                                            <td><small>{{ trabajo.fecha_inicio }}</small></td>
                                                            <td><small>{{ trabajo.fecha_fin }}</small></td>
                                                            <td>
                                                                <input v-if="trabajo.seleccionable" type="checkbox" @change="cambiochecktr(operario,trabajo)" v-model="trabajo.check">
                                                                <small v-if="trabajo.reclamado">RECLAMADO</small>
                                                                <small v-if="trabajo.reclamado_anulado">RECLAMADO ANULADO</small>
                                                            </td>
                                                        </tr>
                                                    </tbody>                                    
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="4">
                                        </td>
                                        <td style="text-align:right;">
                                            <span style="font-weight: bold;">TOTAL: </span><span>{{ total }}</span>
                                        </td>
                                        <td style="text-align:right;">
                                            <span style="font-weight: bold;">TOTAL + IVA: </span><span> {{ total_iva }}</span>
                                        </td>
                                        <td v-if="camposextra" style="text-align:right;"><span>Total pte. CIA: {{ total_pendiente_cia }}</span></td>
                                        <td v-if="camposextra" style="text-align:right;"><span>Total liq. CIA: {{ total_facturado_cia }}</span></td>
                                        <td v-if="camposextra" style="text-align:right;"><span>Total cob. CIA: {{ total_cobrado_cia }}</span></td>
                                        <td>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="4">
                                        </td>
                                        <td colspan="3" v-if="camposextra">
                                        </td>
                                        <td colspan="3" align="right">
                                            <div class="btn-group">
                                                <button class="btn btn-sm btn-default" @click="exportarCsv()">Exportar</button>
                                                <button class="btn btn-sm btn-default" @click="generar()">Generar</button>
                                                <button class="btn btn-sm btn-default" @click="previoDialog = false; previoCargado = false">Cerrar</button>
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div></div>
                </Dialog>
            </div>
        </div>
        <div class="card">
            <div class="card-body" style="padding:0px;">
                <div class="table-responsive">
                <table class="table w-100 mb-0">
                    <thead>
                        <tr>
                            <th>Nº Factura</th>
                            <th>Fecha inicio</th>
                            <th>Fecha fin</th>
                            <th>Operario</th>
                            <th>Empresa</th>
                            <th>Pagada</th>
                            <th>Exportada</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style="min-width: 170px;">
                                <div class="input-group">
                                <input type="number" class="form-control form-control-sm" v-model="numeroFilt" style="max-width:80px;" placeholder="Nº">
                                <input type="number" v-model="añoFilt" class="form-control form-control-sm" style="max-width:80px;" placeholder="Año">
                                </div>
                            </td>
                            <td style="min-width: 100px;">
                                <input class="form-control form-control-sm" type="date" v-model="fechaInicioFilt">
                            </td>
                            <td style="min-width: 100px;">
                                <input class="form-control form-control-sm" type="date" v-model="fechaFinFilt">
                            </td>
                            <td style="min-width: 200px;">
                                <input type="text" class="form-control form-control-sm" v-model="operarioFilt" placeholder="Nombre">
                            </td>
                            <td style="min-width: 200px;">
                                <select v-model="empresaSelecFilt" class="form-control form-control-sm" name="" id="emprr">
                                    <option value="">Todas</option>
                                    <option v-for="empr in empresas" :key="empr.id" :value="empr.id">{{ empr.nombre_empresa }}</option>
                                </select>
                            </td>
                            <td>
                                <select v-model="pagadaFilt" class="form-control form-control-sm" name="" id="pag">
                                    <option value="">--</option>
                                    <option value="SI">Si</option>
                                    <option value="NO">No</option>
                                </select>
                            </td>
                            <td>
                                <select v-model="exportadaFilt" class="form-control form-control-sm" name="" id="exp">
                                    <option value="">--</option>
                                    <option value="SI">Si</option>
                                    <option value="NO">No</option>
                                </select>
                            </td>
                            <td align="right">
                                <div class="btn-group">
                                    <button class="btn btn-sm btn-default" @click="obtenerFacturas()">
                                        <i class="fas fa-search"></i>
                                        Buscar
                                    </button>
                                    <button type="button" class="btn btn-sm btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-controls="dropdownMenu2">
                                        <i class="far fa-file"></i>
                                        Exportar
                                    </button>
                                    <ul id="dropdownMenu2" @click.stop="" class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        <li v-for="selector in selectores" :key="selector.id" class="dropdown-item"><a href="#" @click="exportar(selector.id)">{{ selector.nombre }}</a></li>
                                    </ul>
                                    <button class="btn btn-sm btn-default" @click="exportarFacturas()"><i class="far fa-file"></i>
                                        Excel
                                    </button>
                                    <button class="btn btn-sm btn-default" @click="abrirWeblistado" >Listado PDF ({{ fechasuma0 }}-{{ fechasuma }})</button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
                <DataTable
                    :totalRecords="Number(totalRecords)"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                    stripedRows
                    v-model:filters="filters" 
                    :value="listaFiltrada" 
                    :paginator="true" 
                    :rows="25" 
                    dataKey="id" 
                    :lazy="true"
                    @page="obtenerFacturas($event)"
                    ref="tabla"
                    :loading="loading">
                    
                    <template #empty> No hay facturas disponibles. </template>
                    <template #footer>
                        <div class="col" style="max-width: 300px;">
                            <label class="">Marcar pagadas</label>
                            <div class="input-group" title="Marcar pagadas">
                                <div class="input-group-prepend">
                                    <input type="date" class="form-control form-control-sm" v-model="fechaPagar">
                                </div>
                                <div class="input-group-append">
                                    <span class="input-group-text"><i class="fas fa-check" @click="pagar()"></i></span>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!-- Column Definitions -->
                     <Column v-if="prefacturaActivada">
                        <template #header>
                            <div class="d-flex justify-content-between">
                                <strong>Estado aprobación</strong>                                
                            </div>
                        </template>
                        <template #body="{ data }">
                            {{ data.estado }}
                        </template>
                    </Column>
                    <Column>
                        <template #header>
                            <div class="d-flex justify-content-between">
                                <strong>Nº Factura</strong>
                                <button @click="toggleOrden('numero')" :aria-sort="numeroOrdenAscendente ? 'ascending' : 'descending'" class="btn btn-sm">
                                    <i :class="numeroIcon"></i>
                                </button>
                            </div>
                        </template>
                        <template #body="{ data }">
                            {{ data.numero }}
                        </template>
                    </Column>
                    <Column>
                        <template #header>
                            <div class="d-flex justify-content-between">
                                <strong>Fecha</strong>
                                <button @click="toggleOrden('fecha')" :aria-sort="fechaOrdenAscendente ? 'ascending' : 'descending'" class="btn btn-sm">
                                    <i :class="fechaIcon"></i>
                                </button>
                            </div>
                        </template>
                        <template #body="{ data }">
                            <div v-if="data.bloqueos.modificar_fecha == '1'">
                                <input @input="cambiarFecha(data)" type="date" v-model="data.fecha">
                            </div>
                            <div v-else>
                                {{ data.fecha }}
                            </div>
                        </template>
                    </Column>
                    <Column>
                        <template #header>
                            <div class="d-flex justify-content-between">
                                <strong>Operario</strong>
                            </div>
                        </template>
                        <template #body="{ data }">
                            {{ data.emisor }}
                        </template>
                    </Column>
                    <Column>
                        <template #header>
                            <div class="d-flex justify-content-between">
                                <strong>Cuenta</strong>
                            </div>
                        </template>
                        <template #body="{ data }">
                            {{ data.cuenta_emisor }}
                        </template>
                    </Column>
                    <Column>
                        <template #header>
                            <div class="d-flex justify-content-between">
                                <strong>Base Imponible</strong>
                                <button @click="toggleOrden('base')" :aria-sort="baseOrdenAscendente ? 'ascending' : 'descending'" class="btn btn-sm">
                                    <i :class="baseIcon"></i>
                                </button>
                            </div>
                        </template>
                        <template #body="{ data }">
                            {{ data.importe_base }}
                        </template>
                    </Column>
                    <Column>
                        <template #header>
                            <div class="d-flex justify-content-between">
                                <strong>Total</strong>
                                <button @click="toggleOrden('total')" :aria-sort="totalOrdenAscendente ? 'ascending' : 'descending'" class="btn btn-sm">
                                    <i :class="totalIcon"></i>
                                </button>
                            </div>
                        </template>
                        <template #body="{ data }">
                            {{ data.importe_total }}
                        </template>
                    </Column>
                    <Column>
                        <template #header>
                            <div class="d-flex justify-content-between">
                                <strong>Pago</strong>
                                <button @click="toggleOrden('pago')" :aria-sort="pagoOrdenAscendente ? 'ascending' : 'descending'" class="btn btn-sm">
                                    <i :class="pagoIcon"></i>
                                </button>
                                <input @click="marcarTodas()" type="checkbox">
                            </div>
                        </template>
                        <template #body="{ data }">
                            <div v-if="data.cobrada == 'SI'">
                                {{ data.fecha_cobro }}
                            </div>
                            <div v-else style="display: flex; justify-content: center;">
                                <input @click="marcar(data)" :checked="marcadas.includes(data.id)" type="checkbox">
                            </div>
                        </template>
                    </Column>
                    <Column>
                        <template #header>
                            <div class="d-flex justify-content-between">
                                <strong>Exportada</strong>
                            </div>
                        </template>
                        <template #body="{ data }">
                            {{ data.exportada }}
                        </template>
                    </Column>
                    <Column>
                        <template #header>
                            <div class="d-flex justify-content-between">
                                <strong>Intervalo</strong>
                            </div>
                        </template>
                        <template #body="{ data }">
                            {{ data.intervalo }}
                        </template>
                    </Column>
                    <Column>
                        <template #header>
                            <div class="d-flex justify-content-between">
                                <strong>Factura PDF</strong>
                            </div>
                        </template>
                        <template #body="{ data }">
                            <div style="display: flex;">
                                <button class="btn" @click="abrirPDF(data)" title="Ver factura"><i class="far fa-file-pdf"></i></button>
                                <button class="btn" v-if="data.urls_descarga.completa_pdf_ampliado" @click="abrirPDFAmplidado(data)" title="Ver factura ampliada"><i class="fas fa-file-medical"></i></button>
                                <button class="btn" v-if="data.urls_descarga.completa_xml" @click="abrirXML(data)" title="XML VeriFactu"><i class="fa fa-code"></i></button>
                            </div>
                        </template>
                    </Column>
                    <Column>
                        <template #header>
                            <div class="d-flex justify-content-between">
                                <strong>Factura Excel</strong>
                            </div>
                        </template>
                        <template #body="{ data }">
                            <button class="btn" @click="abrirExcel(data)" title="Ver factura"><i class="far fa-file-excel"></i></button>
                        </template>
                    </Column>
                    <Column>
                        <template #header>
                            <div class="d-flex justify-content-between">
                                <strong>Enviar email</strong>
                            </div>
                        </template>
                        <template #body="{ data }">
                            <div style="display: flex;" v-if="data.email_operario && data.email_operario !== ''">
                                <button v-if="data.urls_envio_email && data.urls_envio_email?.completa_pdf" 
                                        class="btn" 
                                        @click="enviarEmail(data)" 
                                        title="Enviar email">
                                    <i class="far fa-envelope"></i>
                                </button>
                                <button v-if="data.urls_envio_email && data.urls_envio_email?.completa_pdf_ampliado" 
                                        class="btn" 
                                        @click="enviarEmailAmpliado(data)" 
                                        title="Enviar email ampliado">
                                    <i class="fas fa-folder-plus"></i>
                                </button>
                            </div>
                        </template>
                    </Column>
                    <Column>
                        <template #header>
                            <div class="d-flex justify-content-between">
                                <strong>Método Autofactura</strong>
                            </div>
                        </template>
                        <template #body="{ data }">
                            {{ data.metodo }}
                        </template>
                    </Column>
                    <Column>
                        <template #header>
                            <div class="d-flex justify-content-between">
                                <strong>VeriFactu</strong>
                            </div>
                        </template>
                        <template #body="{ data }">
                            {{ data.verifactu }}
                        </template>
                    </Column>
                    <Column>
                        <template #body="{ data }">
                            <div style="display: grid; align-items: center">
                                <div>
                                    <button v-if="!leyAntiActivada" class="btn btn-sm btn-danger"  @click="eliminarFactura(data)" title="Eliminar factura"><i class="fas fa-times"></i></button>
                                    <button class="btn btn-sm btn-default" v-if="data.bloqueos.remarcar_pendiente == '1'" @click="data.visibleMarcar=true" title="Remarcar pendiente"><i class="fas fa-check-double"></i></button>
                                </div>
                            </div>
                            <Dialog 
                            modal
                            header="Marcar pendiente" 
                            v-model:visible="data.visibleMarcar">
                            <div>
                                <textarea v-model="data.motivoMarcar" placeholder="Indica un motivo."></textarea>
                            </div>
                            <div>
                                <button @click="remarcar(data)" class="btn btn-sm btn-default">Marcar pendiente</button>
                                <button class="btn btn-sm btn-default" @click="data.visibleMarcar=false">Cerrar</button>
                            </div>
                            </Dialog>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
    <section :class="content">
        <form id="Factura" :action="'https://' + direccionglobal + urlabrir" method="post" target="TheWindow">
            <input type="text" v-show="nomostrar" v-model="verifactu" name="verifactu">
            <input type="text" v-show="nomostrar" v-model="fechaCambiadaInicio" name="inicio">
            <input type="text" v-show="nomostrar" v-model="fechaCambiadaFin" name="final">
        </form>
    </section>
</template>
<script>
import jsonToCsvExport from "json-to-csv-export";
import Dialog from 'primevue/dialog';
import { PwgsApi } from '../../../services/PwgsApi';
import Dropdown from 'primevue/dropdown';
export default{    
    data(){
        return{
            verifactu:0,
            nomostrar:false,
            fechaCambiadaInicio: '',
            fechaCambiadaFin: '',
            urlabrir:'',
            direccionglobal: localStorage.getItem('direccion'),
            fechasuma:'',
            fechasuma0:'',
            no_factura: localStorage.getItem('no_factura'),
            sistema_facturacion: localStorage.getItem('sistema_facturacion'),
            verifactuActivado:false,
            leyAntiActivada:false,
            prefacturaActivada:false,
            camposextra:false,
            provoper:[],
            selectedprovoper:{label: 'Todos', value: ''},
            empresas:[],
            empresaselec:'',
            inicioBloqueado:false,
            finBloqueado:false,
            fechaInicio:'',
            fechaInicioFilt:'',
            fechaFinFilt:'',
            operarioFilt:'',
            empresaSelecFilt:'',
            fechaFin:'',
            fechaFactura:'',
            nFactura:0,
            nFacturaBloqueado:true,
            previoDialog:false,
            autofacturas:[],
            operarios:[],
            ordenAscendente: false,
            checktodos :true,
            total:0,
            totalgeneral:0,
            total_pendiente_cia:0,
            total_facturado_cia:0,
            total_cobrado_cia:0,
            total_pendientegeneral:0,
            total_facturadogeneral:0,
            total_cobradogeneral:0,
            total_iva:0,
            total_ivageneral:0,
            añoFilt:'',
            pagadaFilt:'',
            exportadaFilt:'',
            ordenarPor: 'numero',
            numeroOrdenAscendente:true,
            fechaOrdenAscendente:false,
            baseOrdenAscendente:false,
            totalOrdenAscendente:false,
            pagoOrdenAscendente:false,
            pagoIcon:'fas fa-sort-up',
            totalIcon:'fas fa-sort-up',
            fechaIcon: 'fas fa-sort-up',
            baseIcon: 'fas fa-sort-up',
            numeroIcon: 'fas fa-sort-down',
            facturas:[],
            marcadas:[],
            fecgaPagar:'',
            spinner:false,
            loading:false,
            todas:false,
            selectores:[],
            numeroFilt:'',
            totalRecords:0,
            previoCargado:false,
            autofacturaampliada: 0,
        }
    },
    components:{
        Dialog,
        Dropdown
    },
    computed: {        
        listaFiltrada() {            
            if (this.facturas && this.facturas.length >0) {
                let filtrados = [...this.facturas];
                filtrados.sort((a, b) => {
                    if(this.ordenarPor == 'fecha') {                        
                        const fechaA = this.parseDate(a.fecha);
                        const fechaB = this.parseDate(b.fecha);
                        return this.fechaOrdenAscendente ? fechaB - fechaA : fechaA - fechaB;                   
                    }else if(this.ordenarPor == 'pago') {
                        const fechaA = this.parseDate(a.fecha_cobro);
                        const fechaB = this.parseDate(b.fecha_cobro);
                        return this.pagoOrdenAscendente ? fechaB - fechaA : fechaA - fechaB; 
                    } else if (this.ordenarPor === 'numero') {
                        const valorA = parseInt(a.numero.split('/')[0]);
                        const valorB = parseInt(b.numero.split('/')[0]);      
                        return this.numeroOrdenAscendente ? valorB - valorA : valorA - valorB;
                    } else if (this.ordenarPor === 'base') {
                        const valorA = parseFloat(a.importe_base);
                        const valorB = parseFloat(b.importe_base);
                        return this.baseOrdenAscendente ? valorB - valorA : valorA - valorB;
                    }else{
                        const valorA = parseFloat(a.importe_total);
                        const valorB = parseFloat(b.importe_total);
                        return this.totalOrdenAscendente ? valorB - valorA : valorA - valorB;
                    }
                });
                return filtrados;
            } else {             
                return [];
            }
        }
    },
    methods:{
        async exportarFacturas(){
            const api = new PwgsApi();
            var body = {fecha_inicio: this.fechaesp(this.fechaInicioFilt), fecha_fin: this.fechaesp(this.fechaFinFilt)};
            if(this.empresaSelecFilt != ''){
                body.id_empresa=this.empresaSelecFilt;
            }
            if(this.numeroFilt != ''){
                body.numero=this.numeroFilt;
            }
            if(this.añoFilt != ''){
                body.year=this.añoFilt;
            }
            if(this.pagadaFilt != ''){
                body.pagada=this.pagadaFilt;
            }
            if(this.exportadaFilt != ''){
                body.exportada=this.exportadaFilt;
            }
            if(this.operarioFilt !=''){
                body.nombre = this.operarioFilt;
            }
            if(this.sistema_facturacion == 'verifactu'){
                body.verifactu = 1;
            }else{
                body.verifactu = 0;
            }
            body.orden = 'numero_factura';
            body.dir_orden = 0;
            body.rows = 1000;
            body.evitar_paginacion = "1";
            try{
                this.$toast.add({ severity: 'success', summary: 'Descarga iniciada', detail: 'Descargando...', life: 5000 });
                const resp = await api.post('facturacion-operarios/autofacturas', body);
                for(let dato of resp.datos){                   
                    var total_percibir = (parseFloat(dato.importe_total)-parseFloat(dato.total_contados)).toFixed(2);
                    delete dato.factura_registro;
                    delete dato.estado_factura;
                    delete dato.email_operario;
                    delete dato.id;
                    delete dato.tipo;
                    delete dato.bloqueos;
                    delete dato.estado;
                    dato['Num'] = dato.numero;
                    delete dato.numero;
                    dato['Fecha'] = dato.fecha;
                    delete dato.fecha;
                    dato['Operario'] = dato.emisor;
                    delete dato.emisor;
                    delete dato.nif_emisor;
                    delete dato.direccion_emisor;
                    delete dato.cp_emisor;
                    delete dato.poblacion_emisor;
                    delete dato.provincia_emisor;
                    delete dato.telefono_emisor;
                    delete dato.email_emisor;
                    dato['Cuenta'] = dato.cuenta_emisor;
                    dato['Base Imponible'] = dato.importe_base.toString().replaceAll(".", ",");
                    dato['Impuesto'] = dato.trabajos[0].iva_trabajos_factura;
                    dato['Importe impuesto'] = dato.iva.toString().replaceAll(".", ",");
                    dato['Retención'] = dato.retencion.toString().replaceAll(".", ",");
                    dato['Total'] = dato.importe_total.toString().replaceAll(".", ",");
                    dato['Contados'] = dato.total_contados;
                    dato['Total a percibir'] = total_percibir.toString().replaceAll(".", ",");
                    delete dato.total_contados;
                    delete dato.retencion;
                    delete dato.cuenta_emisor;
                    delete dato.importe_base;
                    delete dato.importe_total;
                    delete dato.descuento;
                    delete dato.iva;
                    delete dato.contados;
                    delete dato.cobrada;
                    delete dato.exportada;
                    dato['Intervalo'] = dato.intervalo;
                    dato['Método autofactura'] = dato.metodo;
                    delete dato.intervalo;
                    delete dato.metodo;
                    delete dato.urls_descarga;
                    delete dato.cliente;
                    delete dato.nif_cliente;
                    delete dato.direccion_cliente;
                    delete dato.cp_cliente;
                    delete dato.poblacion_cliente;
                    delete dato.provincia_cliente;
                    delete dato.trabajos;
                    delete dato.urls_envio_email;
                    if(dato.fecha_cobro){
                        dato['Fecha cobro'] = dato.fecha_cobro;
                        delete dato.fecha_cobro;
                    }
                }
                let fechahoy = '_F' + new Date().toLocaleDateString().replaceAll('/', '-') + '_T' + new Date().toLocaleTimeString().replaceAll(':', '-');
                jsonToCsvExport({ data: Object.values(resp.datos), filename: 'Descarga_facturas_' + fechahoy, delimiter: ";" });        
            }catch(e) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        abrirWeblistado(){
            this.urlabrir = '/impreso_autofacturas_listado.php';
            if(this.direccionglobal == 'null.pwgs.app'){
                this.direccionglobal = 'pwgs.raul.pwgs5.interno.apuyen.app'
            }
            this.fechaCambiadaInicio =this.fechasuma0;
            this.fechaCambiadaFin = this.fechasuma;
            console.log('this.fechaCambiadaInicio', this.fechaCambiadaInicio);
            console.log('this.fechaCambiadaFin', this.fechaCambiadaFin);
            window.open('', 'TheWindow');            
            if(this.sistema_facturacion == 'verifactu'){
                this.verifactu = 1;
            }else{
                this.verifactu = 0;
            }
            setTimeout(() => {
                document.getElementById('Factura').submit();
            }, 500);
        },
        async exportarCsv(){
            const api = new PwgsApi();
            var body = {fecha_inicio: this.fechaesp(this.fechaInicio), fecha_fin: this.fechaesp(this.fechaFin), fecha_factura: this.fechaesp(this.fechaFactura)};
            if(!this.selectedprovoper.value == ''){
                var tipo = 'operario';
                if(this.selectedprovoper.value.tipo == 'proveedor'){
                    tipo = 'proveedor';
                }
                body.destinatario= tipo; 
                body.id_destinatario=this.selectedprovoper.value.id;
                body.numero = this.nFactura;
            }
            if(this.empresaselec != ''){
                body.id_empresa=this.empresaselec;
            }
            try{
                var expedientes = [];
                for(let operario of this.operarios){        
                    for(let trabajo of Object.values(operario.trabajos)){
                        if(trabajo.check){
                            expedientes.push(trabajo.seleccionable);
                        }
                    }                
                }
                this.$toast.add({ severity: 'success', summary: 'Descarga iniciada', detail: 'Descargando...', life: 5000 });
                var resp = await api.post('facturacion-operarios/previo', body);
                let dats = [];
                let total = 0;
                let totalIva = 0;
                let totalPendiente = 0;
                let totalFacturado = 0;
                let totalCobrado = 0;
                for(let datos of Object.values(resp.operarios)){
                    dats.push({});
                    dats.push({'Código': datos.operario});
                    for(let trabajo of Object.values(datos.trabajos)){
                        if(expedientes.includes(trabajo.seleccionable)){
                            let tr = {};
                            tr['Código'] = trabajo.expediente;
                            tr['Compañia'] = trabajo.cliente;
                            tr['Total'] = trabajo.importe_total;
                            tr['Total IVA'] = trabajo.importe_iva;
                            tr['Total Pendiente'] = trabajo.pendiente_total;
                            tr['Total Facturado'] = trabajo.facturado_total;
                            tr['Total Cobrado'] = trabajo.cobrado_total;
                            dats.push(tr);
                            
                            total+=parseFloat(trabajo.importe_total);
                            totalIva+=parseFloat(trabajo.importe_iva);
                            totalPendiente+=parseFloat(trabajo.pendiente_total);
                            totalFacturado+=parseFloat(trabajo.facturado_total);
                            totalCobrado+=parseFloat(trabajo.cobrado_total);
                        }
                    }
                }
                let trfinal = {
                    'Total': parseFloat(total.toFixed(2)),
                    'Total IVA': parseFloat(totalIva.toFixed(2)),
                    'Total Pendiente': parseFloat(totalPendiente.toFixed(2)),
                    'Total Facturado': parseFloat(totalFacturado.toFixed(2)),
                    'Total Cobrado': parseFloat(totalCobrado.toFixed(2))
                };
                dats.push({});
                dats.push(trfinal);                
                let fechahoy = '_F' + new Date().toLocaleDateString().replaceAll('/', '-') + '_T' + new Date().toLocaleTimeString().replaceAll(':', '-');
                jsonToCsvExport({ data: dats, filename: 'Descarga_trabajos_' + fechahoy, delimiter: ";" });        
           }catch (e) {                
               this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 2000 });
           }
        },
        abrirPDF(factura){
            var urlglobal = localStorage.getItem('direccion');
            var url = '';
            var tipo_documento = '';
            if(urlglobal == 'null.pwgs.app'){
                const registro = Number(factura.factura_registro);
                if(registro === 1){
                    tipo_documento = factura.urls_descarga.pdf_liquidacion;
                }else{
                    tipo_documento = factura.urls_descarga.pdf;
                }
                url = "https://pwgs.raul.pwgs5.interno.apuyen.app/"+tipo_documento;
            }else{
                const registro = Number(factura.factura_registro);
                if(registro === 1){
                    tipo_documento = factura.urls_descarga.completa_pdf_liquidacion;
                }else{
                    tipo_documento = factura.urls_descarga.completa_pdf;
                }
                url = tipo_documento;
            }
            window.open(url, "Factura", "width=800, height=600");
        },
        async comprobarampliada(){
            const api = new PwgsApi();
            this.autofacturaampliada = await api.get('parametros-pwgs/autofactura_ampliada');
                   

        },
        abrirPDFAmplidado(factura){
            var urlglobal = localStorage.getItem('direccion');
            var url = '';
                        var tipo_documento = '';

            if(urlglobal == 'null.pwgs.app'){
                const registro = Number(factura.factura_registro);
                if(registro === 1){
                     tipo_documento = factura.urls_descarga.pdf_ampliado_liquidacion[1];
                }else{
                     tipo_documento = factura.urls_descarga.pdf_ampliado[1];
                }
                url  = "https://pwgs.raul.pwgs5.interno.apuyen.app/"+factura.tipo_documento;
            }else{
                const registro = Number(factura.factura_registro);
                if(registro === 1){
                     tipo_documento = factura.urls_descarga.completa_pdf_ampliado_liquidacion;
                }else{
                     tipo_documento = factura.urls_descarga.completa_pdf_ampliado;
                }
                url = tipo_documento;
            }
            window.open(url, "Factura", "width=800, height=600");
        },
        abrirXML(factura){
            var urlglobal = localStorage.getItem('direccion');
            var url = '';
            var tipo_documento = '';
            if(urlglobal == 'null.pwgs.app'){
                tipo_documento = factura.urls_descarga.completa_xml;
                url = tipo_documento;
            }else{
                tipo_documento = factura.urls_descarga.completa_xml;
                url = tipo_documento;
            }
            window.open(url, "XML", "width=800, height=600");
        },
        abrirExcel(factura){
            var urlglobal = localStorage.getItem('direccion');
            var url = '';
            var tipo_documento = '';
            if(urlglobal == 'null.pwgs.app'){
                const registro = Number(factura.factura_registro);
                if(registro === 1){
                     tipo_documento = factura.urls_descarga.excel_liquidacion;
                }else{
                     tipo_documento = factura.urls_descarga.excel;
                }
                url  = "https://pwgs.raul.pwgs5.interno.apuyen.app/"+factura.tipo_documento;
            }else{
                const registro = Number(factura.factura_registro);
                if(registro === 1){
                     tipo_documento = factura.urls_descarga.completa_excel_liquidacion;
                }else{
                     tipo_documento = factura.urls_descarga.completa_excel;
                }
                url = tipo_documento;
            }
            window.open(url, "Factura", "width=800, height=600");
        },
        enviarEmail(factura){
            var urlglobal = localStorage.getItem('direccion');
            var url = '';
                        var tipo_documento = '';

            if(urlglobal == 'null.pwgs.app'){
                const registro = Number(factura.factura_registro);
                if(registro === 1){
                     tipo_documento = factura.urls_envio_email.pdf_liquidacion;
                }else{
                     tipo_documento = factura.urls_envio_email.pdf;
                }
                url = "https://pwgs.raul.pwgs5.interno.apuyen.app/"+tipo_documento;
            }else{
                const registro = Number(factura.factura_registro);
                if(registro === 1){
                     tipo_documento = factura.urls_envio_email.completa_pdf_liquidacion;
                }else{
                     tipo_documento = factura.urls_envio_email.completa_pdf;
                }
                url = tipo_documento;
            }
            window.open(url, "Factura", "width=800, height=600");
            this.$toast.add({ severity: 'success', summary: 'Email enviado', detail: 'El email se ha enviado correctamente.', life: 5000 });
        },
        enviarEmailAmpliado(factura){
            var urlglobal = localStorage.getItem('direccion');
            var url = '';
            var tipo_documento = '';
            if(urlglobal == 'null.pwgs.app'){
                const registro = Number(factura.factura_registro);
                if(registro === 1){
                     tipo_documento = factura.urls_envio_email.pdf_ampliado_liquidacion[1];
                }else{
                     tipo_documento = factura.urls_envio_email.pdf_ampliado[1];
                }
                url  = "https://pwgs.raul.pwgs5.interno.apuyen.app/"+tipo_documento;
            }else{
                const registro = Number(factura.factura_registro);
                if(registro === 1){
                     tipo_documento = factura.urls_envio_email.completa_pdf_ampliado_liquidacion;
                }else{
                     tipo_documento = factura.urls_envio_email.completa_pdf_ampliado;
                }
                url = tipo_documento;
            }
            window.open(url, "Factura", "width=800, height=600");
        },
        async remarcar(fact){
            const api = new PwgsApi();
            try {
                if(fact.motivoMarcar == ''){
                    alert('Debes indicar un motivo');
                    return;
                }
                await api.put('facturacion-operarios/remarcar-pendiente/'+fact.id, {motivo:fact.motivoMarcar});
                fact.visibleMarcar = false;
                this.obtenerFacturas();
            } catch (error) {
                console.error('Error al remarcar facturas:', error);
            }
        },
        async exportar(idselector){
            const api = new PwgsApi();
            let ids = [];
            for(var filt of this.listaFiltrada){
                ids.push(filt.id);
            }
            try {
                const response = await api.post('facturacion-operarios/exportacion-contable', 
                    { programa: idselector, ids_facturas: ids }, 
                    { responseType: 'blob' } // Importante: especifica que esperas una respuesta binaria (blob)
                );


                if (!(response instanceof Blob)) {
                    throw new Error('La respuesta no es un archivo válido');
                }


                // Crea una URL para el blob y luego crea un enlace para descargarlo
                const link = document.createElement('a');
                const url = window.URL.createObjectURL(response);

                link.href = url;
                link.setAttribute('download', 'archivo.zip'); // Nombre del archivo descargado
                document.body.appendChild(link);

                // Disparar la descarga
                link.click();

                // Limpieza: eliminar el enlace temporal y revocar el URL
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Error al descargar el archivo:', error);
            }
        },
        async eliminarFactura(factura) {
            if (confirm('¿Desea eliminar la factura '+factura.numero+'?')) {

                const api = new PwgsApi();
                await api.delete('facturacion-operarios/eliminar-factura/' + factura.id);
                this.facturas = [];
                this.obtenerFacturas();
            }
        },
        async anularFactura(factura) {
            if (confirm('¿Desea anular la factura '+factura.numero+'?')) {

                const api = new PwgsApi();
                try{
                    await api.put('facturacion-operarios/anular-factura/' + factura.id);
                    this.facturas = [];
                    this.obtenerFacturas();
                }catch(error){
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                }
            }
        },
        marcarTodas(){
            if(this.todas == false){
                for(var fact of this.listaFiltrada){
                    if(fact.cobrada == "NO"){
                        this.marcar(fact);
                    }
                }
            }else{
                this.marcadas = [];
            }
            this.todas =!this.todas;
        },
        async pagar(){
            if(this.marcadas.length > 0){
                const api = new PwgsApi();
                await api.put('facturacion-operarios/marcar-pagadas', {ids_facturas : this.marcadas, fecha:this.fechaPagar});
                this.facturas = [];
                this.obtenerFacturas();
            }
        },
        async cambiarFecha(factura){
            const api = new PwgsApi();
            await api.put('facturacion-operarios/modificar-fecha/'+factura.id, {fecha:this.fechaesp(factura.fecha)})
            this.facturas = [];
            this.obtenerFacturas();
        },
        marcar(factura){
            var id = factura.id;
            if(this.marcadas.includes(id)){
                this.marcadas = this.marcadas.filter(item => item!== id);
            }else{
                this.marcadas.push(id);
            }
        },  
        parseDate(dateString) {
            if (!dateString || dateString == 'Sin fecha') {
                // Si no hay fecha, devolvemos una fecha muy antigua (por ejemplo, 1 de enero de 1970)
                return new Date('1970-01-01').getTime();
            }
            // Supongamos que el formato de fecha es 'DD/MM/YYYY'
            const [day, month, year] = dateString.split('/');
            // Devolvemos el timestamp (milisegundos desde 1970) para poder comparar
            return new Date(`${year}-${month}-${day}`).getTime();
        },        
        async obtenerSelectores(){
            const api = new PwgsApi();
            var response = await api.get('facturacion-operarios/programas-exportacion-contable');
            this.selectores = response.datos;
        },
        async generar(){
            const api = new PwgsApi();
            var expedientes = [];
            for(let operario of this.operarios){        
                for(let trabajo of Object.values(operario.trabajos)){
                    if(trabajo.check && trabajo.seleccionable){
                        expedientes.push(trabajo.seleccionable);
                    }
                }                
            }
            var body = {fecha_inicio: this.fechaesp(this.fechaInicio), fecha_fin: this.fechaesp(this.fechaFin), fecha_factura: this.fechaesp(this.fechaFactura)};
            if(this.empresaselec != ''){
                body.id_empresa=this.empresaselec;
            }
            body.numero = this.nFactura;
            body.expedientes = expedientes;
            try{
                await api.post('facturacion-operarios/facturar', body);
                this.previoDialog = false;
                this.previoCargado = false;
                setTimeout(() => {
                    this.obtenerFacturas();
                    var aux = this.selectedprovoper;
                    this.selectedprovoper = '';
                    setTimeout(() => {
                        this.selectedprovoper = aux;
                    },150);
                }, 1500);
                this.$toast.add({ severity:'success', summary: 'Generado', detail: 'Factura generada correctamente', life: 2000 });
            }catch(e) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }

        },
        toggleOrden(campo) {
            this.ordenarPor = campo;
            if(campo == 'fecha'){
                this.fechaOrdenAscendente = !this.fechaOrdenAscendente;
                this.fechaIcon = this.fechaOrdenAscendente ? 'fas fa-sort-down' : 'fas fa-sort-up';
                this.pagoOrdenAscendente = false;
                this.pagoIcon = 'fas fa-sort-up';
                this.numeroOrdenAscendente = false;
                this.numeroIcon = 'fas fa-sort-up';
                this.baseOrdenAscendente = false;
                this.baseIcon = 'fas fa-sort-up';
                this.totalOrdenAscendente = false;
                this.totalIcon = 'fas fa-sort-up';
            }else if(campo == 'numero'){
                this.numeroOrdenAscendente = !this.numeroOrdenAscendente;
                this.numeroIcon = this.numeroOrdenAscendente ? 'fas fa-sort-down' : 'fas fa-sort-up';
                this.fechaOrdenAscendente = false;
                this.fechaIcon = 'fas fa-sort-up';
                this.pagoOrdenAscendente = false;
                this.pagoIcon = 'fas fa-sort-up';
                this.baseOrdenAscendente = false;
                this.baseIcon = 'fas fa-sort-up';
                this.totalOrdenAscendente = false;
                this.totalIcon = 'fas fa-sort-up';
            }else if(campo == 'base'){
                this.baseOrdenAscendente = !this.baseOrdenAscendente;
                this.baseIcon = this.baseOrdenAscendente ? 'fas fa-sort-down' : 'fas fa-sort-up';
                this.fechaOrdenAscendente = false;
                this.fechaIcon = 'fas fa-sort-up';
                this.numeroOrdenAscendente = false;
                this.numeroIcon = 'fas fa-sort-up';
                this.pagoOrdenAscendente = false;
                this.pagoIcon = 'fas fa-sort-up';
                this.totalOrdenAscendente = false;
                this.totalIcon = 'fas fa-sort-up';
            }else if(campo == 'total'){
                this.totalOrdenAscendente = !this.totalOrdenAscendente;
                this.totalIcon = this.totalOrdenAscendente ? 'fas fa-sort-down' : 'fas fa-sort-up';
                this.fechaOrdenAscendente = false;
                this.fechaIcon = 'fas fa-sort-up';
                this.numeroOrdenAscendente = false;
                this.numeroIcon = 'fas fa-sort-up';
                this.pagoOrdenAscendente = false;
                this.pagoIcon = 'fas fa-sort-up';
                this.baseOrdenAscendente = false;
                this.baseIcon = 'fas fa-sort-up';
            }else{
                this.pagoOrdenAscendente = !this.pagoOrdenAscendente;
                this.pagoIcon = this.pagoOrdenAscendente ? 'fas fa-sort-down' : 'fas fa-sort-up';
                this.fechaOrdenAscendente = false;
                this.fechaIcon = 'fas fa-sort-up';
                this.numeroOrdenAscendente = false;
                this.numeroIcon = 'fas fa-sort-up';
                this.totalOrdenAscendente = false;
                this.totalIcon = 'fas fa-sort-up';
                this.baseOrdenAscendente = false;
                this.baseIcon = 'fas fa-sort-up';
            }
        },
        async obtenerFacturas(event){
            this.loading = true;
            const api = new PwgsApi();
            var body = {fecha_inicio: this.fechaesp(this.fechaInicioFilt), fecha_fin: this.fechaesp(this.fechaFinFilt), rows:25};
            if(event){
                body.first = event.originalEvent.first;
            }
            if(this.empresaSelecFilt != ''){
                body.id_empresa=this.empresaSelecFilt;
            }
            if(this.numeroFilt != ''){
                body.numero=this.numeroFilt;
            }
            if(this.añoFilt != ''){
                body.year=this.añoFilt;
            }
            if(this.pagadaFilt != ''){
                body.pagada=this.pagadaFilt;
            }
            if(this.exportadaFilt != ''){
                body.exportada=this.exportadaFilt;
            }
            if(this.operarioFilt !=''){
                body.nombre = this.operarioFilt;
            }
            console.log('sistema', this.sistema_facturacion);
            if(this.sistema_facturacion == 'verifactu'){
                body.verifactu = 1;
            }else{
                body.verifactu = 0;
            }
            body.orden = 'numero_factura';
            body.dir_orden = 0;
            try{
                var pre = await api.get('parametros-pwgs/pre-autofacturas');
                for(let p of Object.values(pre)){
                    if(p == 1){
                        this.prefacturaActivada = true;
                    }
                }
                var leyAnti = await api.get('parametros-pwgs/actualizacion_ley_antifraude');
                if(leyAnti.actualizacion_ley_antifraude == '1'){
                    this.leyAntiActivada = true;
                }
                const resp = await api.post('facturacion-operarios/autofacturas', body);
                this.facturas = resp.datos;
                this.totalRecords = resp.n_total_registros;
                for(var fact of this.facturas){
                    if(fact.bloqueos.modificar_fecha == '1'){
                        fact.fecha = this.fechaing(fact.fecha);
                    }
                    fact.visibleMarcar = false;
                    fact.motivoMarcar = '';
                }
                this.loading = false;
            }catch(e){
                console.log(e);
                this.loading = false;
            }
        },
        async obtenerFacturasHoy(){
            this.loading = true;
            const api = new PwgsApi();
            const fechaActual = new Date();
            var inicio = new Date(fechaActual.getFullYear(), fechaActual.getMonth() , fechaActual.getDate());
            var body = {fecha_inicio: this.fechaesp(this.fechaing(inicio.toLocaleDateString())), fecha_fin: this.fechaesp(this.fechaing(inicio.toLocaleDateString())), rows:25, year:this.anyoActual()};
            body.orden = 'numero_factura';
            body.dir_orden = 0;
            try{
                var pre = await api.get('parametros-pwgs/pre-autofacturas');
                for(let p of Object.values(pre)){
                    if(p == 1){
                        this.prefacturaActivada = true;
                    }
                }
                var leyAnti = await api.get('parametros-pwgs/actualizacion_ley_antifraude');
                if(leyAnti.actualizacion_ley_antifraude == '1'){
                    this.leyAntiActivada = true;
                }
                const resp = await api.post('facturacion-operarios/autofacturas', body);
                this.facturas = resp.datos;
                this.totalRecords = resp.n_total_registros;
                for(var fact of this.facturas){
                    if(fact.bloqueos.modificar_fecha == '1'){
                        fact.fecha = this.fechaing(fact.fecha);
                    }
                    fact.visibleMarcar = false;
                    fact.motivoMarcar = '';
                }
                this.loading = false;
            }catch(e){
                console.log(e);
                this.loading = false;
            }
        },
        cambiochecktr(operario,trabajo){
            if(trabajo.check){
                this.total += Number(trabajo.importe_total);
                this.total = Math.round(this.total * 100) / 100;
                this.total_iva += Number(trabajo.importe_iva);
                this.total_iva = Math.round(this.total_iva * 100) / 100; 
                if(this.camposextra){
                    this.total_pendiente_cia += Number(trabajo.pendiente_total);
                    this.total_pendiente_cia = Math.round(this.total_pendiente_cia * 100) / 100;
                    this.total_facturado_cia += Number(trabajo.facturado_total);
                    this.total_facturado_cia = Math.round(this.total_facturado_cia * 100) / 100;
                    this.total_cobrado_cia += Number(trabajo.cobrado_total);
                    this.total_cobrado_cia = Math.round(this.total_cobrado_cia * 100) / 100;
                }               
                operario.importe_total += Number(trabajo.importe_total);
                operario.importe_total = Math.round(operario.importe_total * 100) / 100;
                operario.importe_iva += Number(trabajo.importe_iva);
                operario.importe_iva = Math.round(operario.importe_iva * 100) / 100;
                if(this.camposextra){
                    operario.pendiente_total += Number(trabajo.pendiente_total);
                    operario.pendiente_total = Math.round(operario.pendiente_total * 100) / 100;
                    operario.facturado_total += Number(trabajo.facturado_total);
                    operario.facturado_total = Math.round(operario.facturado_total * 100) / 100;
                    operario.cobrado_total += Number(trabajo.cobrado_total);
                    operario.cobrado_total = Math.round(operario.cobrado_total * 100) / 100;
                }
            }else{
                this.total -= Number(trabajo.importe_total);
                this.total = Math.round(this.total * 100) / 100;
                this.total_iva -= Number(trabajo.importe_iva);
                this.total_iva = Math.round(this.total_iva * 100) / 100;
                if(this.camposextra){
                    this.total_pendiente_cia -= Number(trabajo.pendiente_total);
                    this.total_pendiente_cia = Math.round(this.total_pendiente_cia * 100) / 100;
                    this.total_facturado_cia -= Number(trabajo.facturado_total);
                    this.total_facturado_cia = Math.round(this.total_facturado_cia * 100) / 100;
                    this.total_cobrado_cia -= Number(trabajo.cobrado_total);
                    this.total_cobrado_cia = Math.round(this.total_cobrado_cia * 100) / 100;
                }
                operario.importe_total -= Number(trabajo.importe_total);
                operario.importe_total = Math.round(operario.importe_total * 100) / 100;
                operario.importe_iva -= Number(trabajo.importe_iva);
                operario.importe_iva = Math.round(operario.importe_iva * 100) / 100;
                if(this.camposextra){
                    operario.pendiente_total -= Number(trabajo.pendiente_total);
                    operario.pendiente_total = Math.round(operario.pendiente_total * 100) / 100;
                    operario.facturado_total -= Number(trabajo.facturado_total);
                    operario.facturado_total = Math.round(operario.facturado_total * 100) / 100;
                    operario.cobrado_total -= Number(trabajo.cobrado_total);
                    operario.cobrado_total = Math.round(operario.cobrado_total * 100) / 100;
                }
            }
        },
        cambiocheck(operario){
            if(!operario.check){
                for(let trabajo of Object.values(operario.trabajos)){
                    if(!trabajo.check){
                        trabajo.check = true;
                        this.total += Number(trabajo.importe_total);
                        this.total = Math.round(this.total * 100) / 100;
                        this.total_iva += Number(trabajo.importe_iva);
                        this.total_iva = Math.round(this.total_iva * 100) / 100;
                        if(this.camposextra){
                            this.total_pendiente_cia += Number(trabajo.pendiente_total);
                            this.total_pendiente_cia = Math.round(this.total_pendiente_cia * 100) / 100;
                            this.total_facturado_cia += Number(trabajo.facturado_total);
                            this.total_facturado_cia = Math.round(this.total_facturado_cia * 100) / 100;
                            this.total_cobrado_cia += Number(trabajo.cobrado_total);
                            this.total_cobrado_cia = Math.round(this.total_cobrado_cia * 100) / 100;
                        }
                    }
                    operario.importe_total = operario.totalgeneral;
                    operario.importe_iva = operario.total_ivageneral;                    
                    if(this.camposextra){
                        operario.pendiente_total = operario.total_pendientegeneral;
                        operario.facturado_total = operario.total_facturadogeneral;
                        operario.cobrado_total = operario.total_cobradogeneral;
                    }
                }
            }else{
                for(let trabajo of Object.values(operario.trabajos)){
                    if(trabajo.check){
                        trabajo.check = false;
                        this.total -= trabajo.importe_total;
                        this.total = Math.round(this.total * 100) / 100;
                        this.total_iva -= trabajo.importe_iva;
                        this.total_iva = Math.round(this.total_iva * 100) / 100;
                        if(this.camposextra){
                            this.total_pendiente_cia -= trabajo.pendiente_total;
                            this.total_pendiente_cia = Math.round(this.total_pendiente_cia * 100) / 100;
                            this.total_facturado_cia -= trabajo.facturado_total;
                            this.total_facturado_cia = Math.round(this.total_facturado_cia * 100) / 100;
                            this.total_cobrado_cia -= trabajo.cobrado_total;
                            this.total_cobrado_cia = Math.round(this.total_cobrado_cia * 100) / 100;
                        }
                    }
                    operario.importe_total = 0;
                    operario.importe_iva = 0;
                    if(this.camposextra){
                        operario.pendiente_total = 0;
                        operario.facturado_total = 0;
                        operario.cobrado_total = 0;                    
                    }
                }
            }
        },
        async cargarPrevio(){
            this.spinner = true;
            const api = new PwgsApi();
            var body = {fecha_inicio: this.fechaesp(this.fechaInicio), fecha_fin: this.fechaesp(this.fechaFin), fecha_factura: this.fechaesp(this.fechaFactura)};
            if(!this.selectedprovoper.value == ''){
                var tipo = 'operario';
                if(this.selectedprovoper.value.tipo == 'proveedor'){
                    tipo = 'proveedor';
                }
                body.destinatario= tipo; 
                body.id_destinatario=this.selectedprovoper.value.id;
                body.numero = this.nFactura;
            }
            if(this.empresaselec != ''){
                body.id_empresa=this.empresaselec;
            }
            body.liquidacion = 0;
            body.sistema = this.sistema_facturacion;
            try{
                var resp = await api.post('facturacion-operarios/previo', body);
                var opers = Object.values(resp.operarios);
                //ordenar alfabéticamente por operario.operario 
                opers.sort((a, b) => a.operario.localeCompare(b.operario));
                this.operarios = opers;

                for(let operario of this.operarios){
                    operario.mostrar = false;
                    operario.check = true;
                    operario.totalgeneral = operario.importe_total;
                    operario.total_ivageneral = operario.importe_iva;
                    if(this.camposextra){
                        operario.total_pendientegeneral = operario.pendiente_total;
                        operario.total_facturadogeneral = operario.facturado_total;
                        operario.total_cobradogeneral = operario.cobrado_total;
                    }
                    for(let trabajo of Object.values(operario.trabajos)){
                        trabajo.check = true;
                    }
                }
                this.total = resp.total_base;
                this.totalgeneral = resp.total_base;
                this.total_iva = resp.total_iva;
                this.total_ivageneral = resp.total_iva;
                if(this.camposextra){
                    this.total_pendiente_cia = resp.pendiente_total;
                    this.total_pendientegeneral = resp.pendiente_total;
                    this.total_facturado_cia = resp.facturado_total;
                    this.total_facturadogeneral = resp.facturado_total;
                    this.total_cobrado_cia = resp.cobrado_total;
                    this.total_cobradogeneral = resp.cobrado_total;
                }
                this.previoDialog = true;
                this.previoCargado = true;
                this.checktodos = true;
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
                this.spinner = false;
            }finally{
                this.spinner = false;
            }
        },
        irAExpediente(trabajo){
            this.previoDialog = false;
            localStorage.setItem('nombreservicio'+trabajo.id_servicio,trabajo.expediente);
            this.$router.push({
                name: 'Servicio',
                params: {
                    id: trabajo.id_servicio,
                    nombreservicio:trabajo.expediente,
                }
            });
        },
        async obtenerDatos(){            
            const api = new PwgsApi();
            const response = await api.get('facturacion-operarios');
            var operarios = response.operarios;
            var proveedores =response.proveedores;
            this.empresas = response.empresas;
            this.inicioBloqueado = response.bloqueos.fechas.inicio == 1;
            this.finBloqueado = response.bloqueos.fechas.fin == 1;
            this.fechaInicio = this.fechaing(response.fechas.inicio);
            this.fechaFin = this.fechaing(response.fechas.fin);
            this.fechaFactura = this.fechaing(response.fechas.factura);
            var auxoperarios = {label:'Operarios', items:[]};
            var auxproveedores = {label:'Proveedores', items:[]};
            if(operarios.length > 0){
                operarios.forEach(operario => {
                    auxoperarios.items.push({label:operario.nombre, value:{id:operario.id, tipo:'operario'}});
                });
            }
            if(proveedores.length > 0){
                proveedores.forEach(proveedor => {
                    auxproveedores.items.push({label:proveedor.nombre_proveedor, value:{id:proveedor.id, tipo:'proveedor'}});
                });
            }
            this.provoper.push({label:'Todos', items: [
                {label: 'Todos', value: ''},
            ]});
            this.provoper.push(auxoperarios);
            this.provoper.push(auxproveedores);
        },
        async obtenerNFactura(){
            const api = new PwgsApi();
            var tipo = 'operario';
                if(this.selectedprovoper.value.tipo == 'proveedor'){
                    tipo = 'proveedor';
            }
            const response = await api.post('facturacion-operarios/siguiente-numero',{destinatario: tipo, id_destinatario:this.selectedprovoper.value.id, year: this.anyoActual()});
            this.nFactura = response[0].numero;
        },
        anyoActual(){
            return new Date().getFullYear();
        },
        fechaing(fecha) {
            const [dia, mes, año] = fecha.split("/");
            return `${año}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
        },
        fechaesp(fecha) {
            const [año, mes, dia] = fecha.split("-");
            return `${dia}/${mes}/${año}`;
        },
        obtenerfechasiniciales(){
            const fechaActual = new Date();
            this.fechaPagar = this.fechaing(fechaActual.toLocaleDateString());
            var inicio = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
            this.fechaInicioFilt = this.fechaing(inicio.toLocaleDateString());
            var fin = new Date(fechaActual.getFullYear(), fechaActual.getMonth() + 1, 0);
            this.fechaFinFilt = this.fechaing(fin.toLocaleDateString());
            this.obtenerFacturas();
        },
        async comprobarExtra(){
            const api = new PwgsApi();
            const ia = await api.get('parametros-pwgs/previo_autofacturacion_columnas_extra');
            if(ia['previo_autofacturacion_columnas_extra']==1){
                this.camposextra=true;
            }
            var sistemaverifactu = await api.get('sistema-facturacion/verifactu');
            if(sistemaverifactu.sistema_facturacion == '1'){
                this.verifactuActivado = true;
            }
        },
        sumardias() {
            if (!this.fechaInicioFilt || !this.fechaFinFilt) return;

            const fechaMax = new Date(this.fechaInicioFilt);

            fechaMax.setDate(fechaMax.getDate() + 30);

            const fechaFin = new Date(this.fechaFinFilt);

            this.fechasuma0 = this.fechaesp(this.fechaInicioFilt);

            if (fechaFin > fechaMax) {
                this.fechasuma = this.fechaesp(this.formatearFecha(fechaMax));
            } else {
                this.fechasuma = this.fechaesp(this.fechaFinFilt);
            }
        },

        formatearFecha(fecha) {
            const año = fecha.getFullYear();
            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const dia = String(fecha.getDate()).padStart(2, '0');
            return `${año}-${mes}-${dia}`;
        }
    },
    activated(){
        if(this.previoCargado){
            this.previoDialog = true;
        }
    },
    mounted(){
        this.comprobarExtra();
        this.lazyParams = {
            first: 0,
            rows: 25,
        };
        this.obtenerSelectores();
        this.obtenerfechasiniciales();
        this.obtenerDatos();
        this.añoFilt=this.anyoActual();
        this.comprobarampliada();
    },
    watch:{
        fechaFinFilt(){
            this.sumardias();
        },
        fechaInicioFilt(){
            this.sumardias();  
        },
        selectedprovoper(value){
            if(value.value == ''){
                this.nFacturaBloqueado = true;
                this.nFactura = 0;
            }else{
                this.nFacturaBloqueado = false;
                this.obtenerNFactura();
            }
        },
        checktodos(value){
            if(value){
                for(let operario of this.operarios){
                    operario.check = true;
                    for(let trabajo of Object.values(operario.trabajos)){
                        trabajo.check = true;
                    }
                    operario.importe_total = operario.totalgeneral;
                    operario.importe_iva = operario.total_ivageneral;
                    if(this.camposextra){
                        operario.pendiente_total = operario.total_pendientegeneral;
                        operario.facturado_total = operario.total_facturadogeneral;
                        operario.cobrado_total = operario.total_cobradogeneral;
                    }
                }
                this.total = this.totalgeneral;
                this.total_iva = this.total_ivageneral;
                if(this.camposextra){
                    this.total_facturado_cia = this.total_facturadogeneral;
                    this.total_cobrado_cia = this.total_cobradogeneral;
                    this.total_pendiente_cia = this.total_pendientegeneral;
                }
            }else{
                for(let operario of this.operarios){
                    operario.check = false;
                    for(let trabajo of Object.values(operario.trabajos)){
                        trabajo.check = false;
                    }
                    operario.importe_total = 0;
                    operario.importe_iva = 0;
                    if(this.camposextra){
                        operario.pendiente_total = 0;
                        operario.facturado_total = 0;
                        operario.cobrado_total = 0;                    
                    }
                }
                this.total = 0;
                this.total_iva = 0;
                if(this.camposextra){
                    this.total_facturado_cia = 0;
                    this.total_cobrado_cia = 0;
                    this.total_pendiente_cia = 0;
                }
            }
        }
    }
}
</script>
<style>
.difuminado{
        filter: blur(6px);
            pointer-events: none;
            -webkit-user-select: none;
                /* Safari */
            -ms-user-select: none;
                /* IE 10 and IE 11 */
            user-select: none;
                /* Standard syntax */
}
.spinner {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: 9px solid;
    border-color: #d9e3ff;
    border-right-color: #007bff;
    animation: spinner-d3wgkg 1s infinite linear;
    position: absolute;
    z-index:1000;
    top: 50%;
    left: 50%;
    margin-left: -50px;
    margin-top: -50px;
         
}

@keyframes spinner-d3wgkg {
    to {
        transform: rotate(1turn);
    }
}
</style>